import React from 'react';

const Vue_Events = () => {
  return (
    <div>
      <h1>Vue_Events Component</h1>
      <p>This is the Vue_Events tutorial page.</p>
    </div>
  );
}

export default Vue_Events;
